import { render, staticRenderFns } from "./FormOffer.vue?vue&type=template&id=0afd1e59&scoped=true&"
import script from "./FormOffer.vue?vue&type=script&lang=ts&"
export * from "./FormOffer.vue?vue&type=script&lang=ts&"
import style0 from "./FormOffer.vue?vue&type=style&index=0&id=0afd1e59&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afd1e59",
  null
  
)

export default component.exports